import { EditFlashMessageDto } from '../../../dto/flashmessage/edit/editflashmessagedto';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface EditFlashMessageResponse extends MiddlewareAPIResponse
{
    getFlashMessageResponseDto(): EditFlashMessageDto;
}

export class EditFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements EditFlashMessageResponse
{
    private getFlashMessageDto : EditFlashMessageDto;

    getFlashMessageResponseDto(): EditFlashMessageDto
    {
        return this.getFlashMessageDto;
    }

    setFlashMessageResponseDto(getFlashMessageDto: EditFlashMessageDto)
    {
        this.getFlashMessageDto = getFlashMessageDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/edit/editflashmessagesresponse.tsx